import Choices from 'choices.js';
import * as helpers from '../helpers';
import { hasNativeDatePicker } from './stratis_datepicker';

export default class PassSport {
    constructor(selector = '.qwe', options = {}) {
        this.selector = selector;

        // Plugin options
        this.options = {};

        this.init();
    }

    init() {
        this.manageFirstDisciplineField();
        this.childrensIndenticalValidation();
        this.childDateValidation();
        this.initCopyBlockEvents();
        this.ajaxI();
        this.ajaxS();
        this.initAjaxSelectFill();
        this.showHideBlock();
    }

    /**
     * Because BE cannot do this
     */
    manageFirstDisciplineField() {
        const firstDiscipline = document.querySelector('[data-ajs-discipline-url]');

        if (!firstDiscipline) {
            return;
        }

        const disciplineLabel = firstDiscipline.parentElement.querySelector('label');

        if (firstDiscipline.getAttribute('required')) {
            disciplineLabel.innerHTML = 'DISCIPLINE <em class="required">(obligatoire)</em>';
        }
    }

    /**
     * Append Error if year of child > 18
     */
    childDateValidation() {
        const childDateElArray = [...document.querySelectorAll('.js-child-date')];

        const addErrorToField = (field, messageText, submitBtn) => {
            const parent = field.parentElement;
            const errorEl = this.createParsleyError(messageText);
            const errorElExist = parent.querySelector('.parsley-errors-list');

            helpers.addClass(field, 'is-error');
            helpers.addClass(field, 'is-error-date');

            if (!errorElExist) {
                helpers.insertAfter(errorEl, field);
            }

            submitBtn.setAttribute('disabled', 'disabled');
        };

        const removeErrorFromField = (field, submitBtn) => {
            const parent = field.parentElement;
            const errorEl = parent.querySelector('.parsley-errors-list');

            if (!helpers.hasClass(field, 'is-error-child')) {
                helpers.removeClass(field, 'is-error');
            }

            helpers.removeClass(field, 'is-error-date');

            const isErrorExist = document.querySelector('.is-error');

            if (!isErrorExist) {
                submitBtn.removeAttribute('disabled');
            }

            if (errorEl) {
                parent.removeChild(errorEl);
            }
        };

        childDateElArray.forEach((el) => {
            const errorText = el.getAttribute('data-message-text');
            const errorTextDefault = 'L\'enfant est dans sa 18ème année et ne peut prétendre';
            const submitBtn = el.form.querySelector('[type="submit"]');

            el.addEventListener('change', (event) => {
                let date = el.value.split('-');

                if (!hasNativeDatePicker()) {
                    date = el.value.split('/').reverse();
                }

                const year = date[0];
                const month = date[1];
                const day = date[2];

                if (date.length < 3 || this.isDateNot18YearsOld(+year, +month, +day)) {
                    removeErrorFromField(el, submitBtn);
                } else {
                    addErrorToField(el, errorText || errorTextDefault, submitBtn);
                }
            });
        });
    }

    /**
     * Check if name, lastname and date equial to another childs
     */
    childrensIndenticalValidation() {
        const blockArrayForValidation = [...document.querySelectorAll('.js-child-validation')];
        const defaultMessageText = 'Cet enfant a déjà été ajouté dans ce formulaire, merci'
            + ' de compléter soit en ajoutant un nouvel enfant soit en supprimant cet enfant';

        blockArrayForValidation.forEach((childBlock) => {
            const childBlockId = childBlock.getAttribute('id');
            const messageId = `message-${childBlockId}`;
            const messageText = childBlock.getAttribute('data-message-text');
            const childBlockNom = childBlock.querySelector('.js-child-nom');
            const childBlockPrenom = childBlock.querySelector('.js-child-prenom');
            const childBlockDate = childBlock.querySelector('.js-child-date');
            const allFields = [childBlockNom, childBlockPrenom, childBlockDate];
            const form = childBlockNom.form;
            const submitBtn = form.querySelector('[type="submit"]');

            const addError = () => {
                this.addErrorToBlock(messageText || defaultMessageText, messageId, childBlock);

                allFields.forEach((field) => {
                    helpers.addClass(field, 'is-error');
                    helpers.addClass(field, 'is-error-child');
                });

                submitBtn.setAttribute('disabled', 'disabled');
            };

            const removeError = () => {
                this.removeErrorFromBlock(messageId);

                allFields.forEach((field) => {
                    helpers.removeClass(field, 'is-error-child');

                    if (!helpers.hasClass(field, 'is-error-date')) {
                        helpers.removeClass(field, 'is-error');
                    }
                });

                const isErrorExist = document.querySelector('.is-error');

                if (!isErrorExist) {
                    submitBtn.removeAttribute('disabled', 'disabled');
                }
            };

            const validate = () => {
                const blockArrayForValidationCopy = [...blockArrayForValidation];
                const blocksToValidate = blockArrayForValidationCopy.filter(block => block.getAttribute('id') !== childBlockId);

                let isError = false;

                blocksToValidate.forEach((blockToValidate) => {
                    if (isError) {
                        return;
                    }

                    const blockToValidateNom = blockToValidate.querySelector('.js-child-nom');
                    const blockToValidatePrenom = blockToValidate.querySelector('.js-child-prenom');
                    const blockToValidateDate = blockToValidate.querySelector('.js-child-date');
                    const allBlockToValidateFields = [
                        childBlockNom, childBlockPrenom, childBlockDate, blockToValidateNom, blockToValidatePrenom, blockToValidateDate,
                    ];

                    let canAddError = true;

                    [...allFields, ...allBlockToValidateFields].forEach((field) => {
                        if (!canAddError) {
                            return;
                        }

                        canAddError = Boolean(field.value);
                    });

                    if (childBlockNom.value.toLowerCase() === blockToValidateNom.value.toLowerCase()
                    && childBlockPrenom.value.toLowerCase() === blockToValidatePrenom.value.toLowerCase()
                    && childBlockDate.value.toLowerCase() === blockToValidateDate.value.toLowerCase()) {
                        if (!canAddError) {
                            return;
                        }

                        isError = true;
                        addError();
                    } else {
                        removeError();
                    }
                });
            };

            allFields.forEach((field) => {
                field.addEventListener('blur', validate.bind(this));
            });
        });
    }

    /**
     * Init ajax on discipline, commune, clubs and federation fields
     */
    ajaxS() {
        const ajDisciplines = [...document.querySelectorAll(':not(.init)[data-ajs-discipline-url]')];

        ajDisciplines.forEach(async (ajDiscipline) => {
            ajDiscipline.classList.add('init');

            const ajCommune = document.querySelector(':not(.init)[data-ajs-commune-url]');
            const ajClub = document.querySelector(':not(.init)[data-ajs-club-url]');
            const ajFederation = document.querySelector(':not(.init)[data-ajs-federation-url]');

            this.hideAjaxS(ajCommune, ajClub, ajFederation);

            if (ajDiscipline) {
                ajDiscipline.value = '';

                ajDiscipline.addEventListener('focus', () => {
                    ajDiscipline.setAttribute('data-prev-value', ajDiscipline.value);
                });

                ajDiscipline.addEventListener('change', () => {
                    const scope = helpers.findAncestor(ajDiscipline, 'form-group') || ajDiscipline.form;

                    this.hideAjaxS(ajCommune, ajClub, ajFederation);
                    this.addDependencyToDisciplines(scope, ajDiscipline.value, ajDiscipline.getAttribute('id'), ajDiscipline.getAttribute('data-prev-value'));

                    if (ajCommune && ajCommune.hasAttribute('data-ajs-commune-url')) {
                        const attr = ajCommune.getAttribute('data-ajs-commune-url');
                        this.fillSelect(ajCommune, attr, ajDiscipline.value, this.setDefaultValueToDynamicSelect.bind(this, ajCommune));
                    }
                });

                if (helpers.hasClass(ajDiscipline, 'js-select-discipline')) {
                    const _ = new Choices(ajDiscipline, {
                        removeItemButton: true,
                        itemSelectText: '',
                        renderChoiceLimit: -1,
                        searchResultLimit: 4,
                        noResultsText: 'Aucun résultat',
                        noChoicesText: 'Aucun choix',
                        fuseOptions: {
                            threshold: 0,
                            location: 0,
                            distance: 50,
                        },
                    });
                }
            }

            if (ajCommune) {
                ajCommune.addEventListener('change', () => {
                    this.hideAjaxS(null, ajClub, ajFederation);

                    if (ajClub && ajClub.hasAttribute('data-ajs-club-url')) {
                        let attr = ajClub.getAttribute('data-ajs-club-url');
                        attr = attr.replace('discipline=', `discipline=${ajDiscipline.value}`);
                        this.fillSelect(ajClub, attr, ajCommune.value, this.setDefaultValueToDynamicSelect.bind(this, ajClub));
                    }
                });
            }

            if (ajClub) {
                const form = ajDiscipline.form;

                ajClub.addEventListener('change', async () => {
                    this.hideAjaxS(null, null, ajFederation);

                    const activeDisciplines = [...document.querySelectorAll('[data-ajs-discipline-url]')]
                        .filter((discipline) => { return !helpers.hasClass(discipline.parentElement, 'is-hidden'); });

                    if (activeDisciplines.length >= 6) {
                        const message = this.createMessage('Vous avez atteint le nombre maximum de 6 demandes pour une même famille.'
                        + ' Merci de bien vouloir contacter les services du Conseil départemental de l’Oise via le courriel suivant pass-sports@oise.fr',
                        'discipline-limit-info',
                        'info');

                        form.insertBefore(message, form.firstElementChild);
                        message.scrollIntoView({
                            block: 'center',
                            behavior: 'smooth',
                        });
                    }

                    if (ajFederation && ajFederation.hasAttribute('data-ajs-federation-url')) {
                        const attr = ajFederation.getAttribute('data-ajs-federation-url');
                        const ajFederationName = ajFederation.getAttribute('name');
                        const hiddenInput = document.createElement('input');

                        await this.fillSelect(ajFederation, attr, ajClub.value, this.setDefaultValueToDynamicSelect.bind(this, ajFederation), false);

                        if (ajFederation.options.length < 1) {
                            helpers.insertAfter(hiddenInput, ajFederation);
                            ajFederation.removeAttribute('name');
                            hiddenInput.setAttribute('type', 'hidden');
                            hiddenInput.setAttribute('name', ajFederationName);
                            hiddenInput.value = ajFederation.value;
                            ajFederation.setAttribute('disabled', 'disabled');
                        }
                    }
                });
            }
        });
    }

    /**
     * After input change make ajax request and fill target select
     */
    initAjaxSelectFill() {
        const selectFillInputArray = [...document.querySelectorAll('.js-fill-select')];

        selectFillInputArray.forEach((input) => {
            const target = document.querySelector(input.getAttribute('data-target'));

            if (!target) {
                console.error('Could not find fill select target');
                return;
            }

            const url = input.getAttribute('data-url');

            target.setAttribute('disabled', 'disabled');

            const doRequest = (event) => {
                let value = input.value;

                if (event) {
                    value = event.target.value;
                }

                if (value.length === 5) {
                    this.fillSelect(target, url, value, (data) => {
                        if (data && data.length) {
                            target.removeAttribute('disabled');
                        } else {
                            target.setAttribute('disabled', 'disabled');
                            const firstOption = target.options[0];
                            target.innerHTML = '';
                            target.appendChild(firstOption);
                        }
                    });
                }
                
                if (value.length > 5) {
                    event.preventDefault();
                    input.value = value.slice(0, 5);
                }
            };

            doRequest();
            ['input'].forEach((eventName) => { input.addEventListener(eventName, doRequest.bind(this)); });
        });
    }

    validateAjiPassportFullness() {
        const passportsFields = [...document.querySelectorAll('[data-aji-passport]')];

        return !passportFields.some(field => !field.value);
    }

    /**
     * Init events on copy and remove blocks button (BE extentions)
     * Clubs form
     */
    initCopyBlockEvents() {
        const copyBtn = document.querySelector('[data-copy-button]');
        const removeBtnArray = [...document.querySelectorAll('[data-remove-button]')];

        if (copyBtn && !helpers.hasClass(copyBtn, 'is-initialized')) {
            helpers.addClass(copyBtn, 'is-initialized');
            copyBtn.addEventListener('click', () => {
                setTimeout(() => {
                    this.initCopyBlockEvents();
                    this.ajaxI();
                }, 500);
            });
        }

        removeBtnArray.forEach((removeBtn) => {
            const submitBtn = removeBtn.form.querySelector('[type="submit"]');

            removeBtn.addEventListener('click', () => {
                setTimeout(() => {
                    const isErrorExist = document.querySelector('.is-error');
                    const isAllPassportFieldFilled = this.validateAjiPassportFullness();

                    if (!isErrorExist && isAllPassportFieldFilled) {
                        submitBtn.removeAttribute('disabled');
                    }
                }, 400);
            });
        });
    }

    /**
     * Init clubs passport fields handler
     */
    ajaxI() {
        const ajPasswords = [...document.querySelectorAll('[data-aji-passport]')];

        ajPasswords.forEach((ajPassword) => {
            const ajPasswordId = ajPassword.getAttribute('id');

            if (helpers.hasClass(ajPassword, `is-initialized-${ajPasswordId}`)) {
                return;
            }

            helpers.addClass(ajPassword, `is-initialized-${ajPasswordId}`);

            const ajBtn = ajPassword.parentElement.querySelector('[data-aji-btn]');
            const form = ajPassword.form;
            const ajSubmit = form.querySelector('[type="submit"]');
            const messageId = `message-${ajPassword.getAttribute('id')}`;
            const messageText = ajPassword.getAttribute('data-message-text');
            const defaultMessageText = '"Ce numéro de "Pass\'Sport" n\'est pas un numéro valide, merci de vérifier votre saisie';
            const lastNameField = ajPassword.parentElement.parentElement.parentElement.querySelector('.js-passport-last-name');
            const nameField = ajPassword.parentElement.parentElement.parentElement.querySelector('.js-passport-name');

            if (lastNameField) {
                lastNameField.value = '';
                lastNameField.parentElement.style.display = 'none';
            }

            if (nameField) {
                nameField.value = '';
                nameField.parentElement.style.display = 'none';
            }

            helpers.addClass(ajBtn, 'is-hidden-i');
            ajSubmit.setAttribute('disabled', 'disabled');

            const checkValueLength = () => {
                if (ajPassword.value.length > 0) {
                    helpers.removeClass(ajBtn, 'is-hidden-i');
                    ajBtn.removeAttribute('disabled', 'disabled');
                } else {
                    helpers.addClass(ajBtn, 'is-hidden-i');
                    ajBtn.setAttribute('disabled', 'disabled');
                }
            };

            ajPassword.addEventListener('input', checkValueLength.bind(this));

            checkValueLength();

            ajBtn.addEventListener('click', async () => {
                if (!ajPassword.value) {
                    return;
                }

                const url = ajPassword.getAttribute('data-aji-passport');
                const data = await this.getData(`${url}${ajPassword.value}`);
                const isFieldWithSameValueExist = ajPasswords.some((passportField) => {
                    return passportField.getAttribute('id') !== ajPassword.getAttribute('id')
                        && passportField.value === ajPassword.value;
                });

                ajSubmit.setAttribute('disabled', 'disabled');

                if (data && !data.error && !isFieldWithSameValueExist) {
                    helpers.removeClass(ajPassword, 'is-error');

                    const isErrorExist = document.querySelector('.is-error');

                    if (!isErrorExist) {
                        ajSubmit.removeAttribute('disabled', 'disabled');
                    }

                    if (lastNameField) {
                        lastNameField.parentElement.style.display = 'block';
                        lastNameField.value = data.lastName;
                        lastNameField.setAttribute('readonly', 'readonly');
                    }

                    if (nameField) {
                        nameField.parentElement.style.display = 'block';
                        nameField.value = data.firstName;
                        nameField.setAttribute('readonly', 'readonly');
                    }

                    this.removeErrorFromBlock(messageId);
                } else {
                    helpers.addClass(ajPassword, 'is-error');
                    helpers.addClass(ajBtn, 'is-hidden-i');
                    ajBtn.setAttribute('disabled', 'disabled');

                    this.addErrorToBlock(messageText || data.error || defaultMessageText, messageId, ajPassword.parentElement.parentElement.parentElement);
                }
            });

            ajBtn.dispatchEvent(helpers.createEvent('click'));
        });
    }

    isDateNot18YearsOld(year, month, day) {
        let maxBirthDate = new Date();
        maxBirthDate = new Date(maxBirthDate.setFullYear(maxBirthDate.getFullYear() - 18));
        const maxYear = maxBirthDate.getFullYear();
        const maxMonthOnMaxYear = maxBirthDate.getMonth() + 1;
        const maxDayOnMaxMonthOnMaxYear = maxBirthDate.getDate();

        if (year < 2003) {
            return false;
        }

        if (year > maxYear) {
            return true;
        }

        if (year === maxYear) {
            if (month > maxMonthOnMaxYear) {
                return true;
            }

            if (month === maxMonthOnMaxYear) {
                if (day >= maxDayOnMaxMonthOnMaxYear) {
                    return true;
                }
            }
        }

        return false;
    }

    createParsleyError(errorText) {
        const message = document.createElement('div');

        helpers.addClass(message, 'parsley-errors-list');
        message.innerHTML = `<p>${errorText}</p>`;

        return message;
    }

    removeErrorFromBlock(messageId) {
        const message = document.querySelector(`#${messageId}`);

        if (message) {
            message.parentNode.removeChild(message);
        }
    }

    addErrorToBlock(errorText, messageId, insertTarget) {
        const message = document.querySelector(`#${messageId}`);
        const messages = [...document.querySelectorAll('.message')]
            .filter((item) => { return !helpers.hasClass(item, 'js-custom-message'); });

        messages.forEach((item) => {
            item.parentElement.removeChild(item);
        });

        if (message) {
            return;
        }

        const newMessage = this.createMessage(
            errorText,
            messageId,
        );

        insertTarget.insertBefore(newMessage, insertTarget.firstChild);

        newMessage.scrollIntoView({
            block: 'center',
            behavior: 'smooth',
        });
    }

    async getData(url) {
        const fe = window.location.hostname === 'localhost' || window.location.hostname === 'integration.stratis.fr';

        if (fe) {
            return new Promise((resolve, _) => {
                setTimeout(() => {
                    resolve(
                        {
                            250: {
                                id: 1,
                                title: 'Test 1',
                            },
                            300: {
                                id: 2,
                                title: 'Test 2',
                            },
                            400: {
                                id: 3,
                                title: 'Test 3',
                            },
                            500: {
                                id: 4,
                                title: 'Test 4',
                            },
                            600: {
                                id: 5,
                                title: 'Test 5',
                            },
                        },
                    );
                }, 500);
            });
        }

        try {
            const response = await fetch(`${url}`, {
                method: 'GET',
            });

            if (response.status >= 200 && response.status < 300) {
                // If status OK return JSON
                return await response.json();
            }
        } catch (error) {
            console.warn('data not found.');
            console.warn(error);
        }
    }

    async fillSelect(select, url, value, cb = () => {}, enableFirstOption = true) {
        let data = [];

        if (value) {
            const dataObject = await this.getData(`${url}${value}`);
            data = Array.isArray(dataObject) ? dataObject : Object.values(dataObject);
        }
        
        if (data && data.length) {
            const firstOption = select.children[0];
            select.innerHTML = '';

            if (enableFirstOption) {
                select.appendChild(firstOption);
            }

            data.forEach((item) => {
                const option = new Option(item.title, item.id);
                select.appendChild(option);
            });

            helpers.removeClass(select.parentElement, 'is-hidden-s');

            if (select.getAttribute('data-required')) {
                helpers.makeBlockRequired(select);
            }
        }

        cb(data);
    }

    hideAjaxS(ajCommune, ajClub, ajFederation) {
        if (ajCommune) {
            helpers.addClass(ajCommune.parentElement, 'is-hidden-s');
            ajCommune.classList.add('init');
            helpers.makeBlockUnRequired(ajCommune);
        }

        if (ajClub) {
            helpers.addClass(ajClub.parentElement, 'is-hidden-s');
            ajClub.classList.add('init');
            helpers.makeBlockUnRequired(ajClub);
        }

        if (ajFederation) {
            helpers.addClass(ajFederation.parentElement, 'is-hidden-s');
            ajFederation.classList.add('init');
            helpers.makeBlockUnRequired(ajFederation);
        }
    }

    /**
     * When option is chosen - disable other same options in other disciplines
     * @param {*} scope - query selector scope
     * @param {*} valueToRemove - target options value
     * @param {*} targetId - main select id
     * @param {*} prevValue - previous select value (needs for undisabling)
     */
    addDependencyToDisciplines(scope, valueToRemove, targetId, prevValue) {
        const ajDisciplines = [...scope.querySelectorAll('[data-ajs-discipline-url]')]
            .filter((item) => { return item.getAttribute('id') !== targetId; });

        ajDisciplines.forEach((ajDiscipline) => {
            if (valueToRemove !== 0 && valueToRemove !== '') {
                const optionToDisable = ajDiscipline.querySelector(`[value="${valueToRemove}"]`);
                optionToDisable.setAttribute('disabled', true);
            }

            ajDisciplines.forEach((discipline) => {
                const optionsToEnable = discipline.querySelector(`[value="${prevValue}"]`);

                if (optionsToEnable) {
                    optionsToEnable.removeAttribute('disabled', true);
                }
            });
        });
    }

    /**
     * Set value from attribute to select
     * @param {HTMLElement} select - target select element
     */
    setDefaultValueToDynamicSelect(select) {
        const defaultValue = select.getAttribute('data-value');
        const isDefaultValueSetted = helpers.hasClass(select, 'is-default-value-setted');

        if (!defaultValue || isDefaultValueSetted) {
            return;
        }

        setTimeout(() => {
            select.value = defaultValue;
            select.dispatchEvent(helpers.createEvent('change'));
            helpers.addClass([select], 'is-default-value-setted');
        }, 500);
    }

    createMessage(text = 'Error', id = '1', type = 'error') {
        const messageContainer = document.createElement('div');

        helpers.addClass(messageContainer, `message -${type} js-custom-message`);
        messageContainer.innerHTML = `<h2>${type === 'error' ? 'Erreur' : 'Info'}</h2><p>${text}</p>`;
        messageContainer.setAttribute('id', id);

        return messageContainer;
    }

    clearInputValuesInsideBlock(block) {
        const inputsToClear = [...block.querySelectorAll('input, select, textarea')];

        inputsToClear.forEach((field) => {
            if (field.getAttribute('type') === 'hidden') {
                return;
            }

            if (field.nodeName === 'SELECT') {
                field.selectedIndex = 0;
            } else if (field.getAttribute('type') === 'radio' || field.getAttribute('type') === 'checkbox') {
                field.checked = false;
            } else {
                field.value = '';
            }

            field.dispatchEvent(helpers.createEvent('change'));
            field.dispatchEvent(helpers.createEvent('blur'));
        });
    }

    showHideBlock() {
        const allShBlocks = [...document.querySelectorAll('[data-sh-block]')];
        allShBlocks.forEach((block) => {
            if (block.hasAttribute('data-sh-block')) {
                let blockIsEmpty = true;
                const attr = block.getAttribute('data-sh-block');

                const fields = [...block.querySelectorAll('input, select')];

                fields.forEach((field) => {
                    if (field.value !== '' && field.value !== 0 && field.value !== '0' && field.value !== 'Y-m-d') {
                        blockIsEmpty = false;
                    }
                });

                if (attr !== 'visible' && blockIsEmpty) {
                    helpers.addClass(block, 'is-hidden');
                    helpers.makeBlockUnRequired(block);
                } else {
                    helpers.removeClass(block, 'is-hidden');
                }
            }
        });

        const closeBtnArray = [...document.querySelectorAll('[data-sh-btn-close]')];
        closeBtnArray.forEach((btn) => {
            if (helpers.hasClass(btn, 'js-hide-close-button')) {
                btn.style.display = 'none';
            }

            if (btn.hasAttribute('data-sh-btn-close')) {
                btn.addEventListener('click', () => {
                    const closeBtnAttr = btn.getAttribute('data-sh-btn-close');
                    const parents = [...document.querySelectorAll(`[data-sh-block="${closeBtnAttr}"]`)];
                    const infoMessage = document.querySelector('#discipline-limit-info');

                    if (infoMessage) {
                        infoMessage.parentElement.removeChild(infoMessage);
                    }

                    if (helpers.hasClass(btn, 'js-hide-close-button')) {
                        btn.style.display = 'none';
                    }

                    parents.forEach((parent) => {
                        const closeButtonsInsideParent = [...parent.querySelectorAll('[data-sh-btn-close]')];

                        closeButtonsInsideParent.forEach((button) => {
                            button.click();
                        });

                        helpers.addClass(parent, 'is-hidden');
                        helpers.makeBlockUnRequired(parent);
                        this.clearInputValuesInsideBlock(parent);
                    });

                    const reg = closeBtnAttr.match(/sh(\/|-|\.)([0-9]*)/gm).join('');

                    if (reg) {
                        const btnClose = document.querySelector(`[data-sh-btn="${reg}"]`);
                        if (btnClose) {
                            btnClose.removeAttribute('disabled');
                        }

                        if (parents && parents[0]) {
                            const isFieldset = parents[0].querySelector('legend');

                            if (!isFieldset) {
                                const targetFieldset = helpers.findAncestor(btn, 'form-group');
                                const firstDiscipline = targetFieldset.querySelector('[data-ajs-discipline-url]');
                                const disciplineLabel = firstDiscipline.parentElement.querySelector('label');
                                const isRequired = firstDiscipline.getAttribute('required');

                                if (isRequired) {
                                    disciplineLabel.innerHTML = 'DISCIPLINE <em class="required">(obligatoire)</em>';
                                } else {
                                    disciplineLabel.innerText = 'DISCIPLINE';
                                }
                            }
                        }
                    }
                });
            }
        });

        const shBtns = [...document.querySelectorAll('[data-sh-btn^="sh-"]')];

        shBtns.forEach((btn) => {
            const btnAttr = btn.getAttribute('data-sh-btn');
            const closeBtn = document.querySelector(`[data-sh-btn-close="${btnAttr}-1"]`);

            btn.addEventListener('click', () => {
                if (!btnAttr) {
                    return;
                }

                const firstFieldset = document.querySelector('.js-child-validation');
                const legendText = firstFieldset.querySelector('legend').firstElementChild;
                const firstBlock = document.querySelector(`.is-hidden[data-sh-block^="${btnAttr}-"]`);

                if (firstBlock) {
                    const firstFocusableEl = helpers.getFirstFocusableElement(firstBlock);
                    const firstAttr = firstBlock.getAttribute('data-sh-block');
                    const shBlocks = [...document.querySelectorAll(`.is-hidden[data-sh-block="${firstAttr}"]`)];
                    const blockIsFieldset = firstBlock.querySelector('legend');

                    if (closeBtn && closeBtn.style.display === 'none') {
                        closeBtn.style.display = 'block';
                    }

                    if (blockIsFieldset) {
                        legendText.innerText = 'Enfant 1';
                    } else {
                        const targetFieldset = helpers.findAncestor(btn, 'form-group');
                        const firstDiscipline = targetFieldset.querySelector('[data-ajs-discipline-url]');
                        const disciplineLabel = firstDiscipline.parentElement.querySelector('label');
                        const isRequired = firstDiscipline.getAttribute('required');

                        if (isRequired) {
                            disciplineLabel.innerHTML = 'DISCIPLINE 1 <em class="required">(obligatoire)</em>';
                        } else {
                            disciplineLabel.innerText = 'DISCIPLINE 1';
                        }
                    }

                    shBlocks.forEach((bl) => {
                        helpers.removeClass(bl, 'is-hidden');
                        helpers.makeBlockRequired(bl);
                    });


                    firstBlock.scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });

                    if (firstFocusableEl) {
                        setTimeout(() => {
                            firstFocusableEl.focus();
                        }, 700);
                    }
                }

                const shBlock = [...document.querySelectorAll(`.is-hidden[data-sh-block^="${btnAttr}-"]`)];

                if (shBlock.length === 0) {
                    btn.setAttribute('disabled', 'disabled');
                }
            });

            const shBlock = [...document.querySelectorAll(`.is-hidden[data-sh-block^="${btnAttr}-"]`)];

            if (shBlock.length === 0) {
                btn.setAttribute('disabled', 'disabled');
            }
        });
    }
}

const passSport = new PassSport();
